import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { CREATE_TIRE_PATCH, UPDATE_TIRE_PATCH } from '../../../constants/graph/mutation'
import { TIRE_PATCH_INFO, TIRE_SERIAL_NUMBER_INFO_FOR_TIRE_PATCH_LOG } from '../../../constants/graph/query'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { ActionBar } from '../../../components/tire-patch-components'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const [tireInfoId, setTireInfoId] = useState()
  const [tirePatchStore, setTirePatchStore] = useState()
  const [patchDate, setPatchDate] = useState()
  const [doAction, { loading: mutationLoading }] = useMutation(isAddMode ? CREATE_TIRE_PATCH : UPDATE_TIRE_PATCH)
  const {
    loading, data, error, refetch,
  } = useQuery(TIRE_PATCH_INFO, { skip: isAddMode, variables: { id: props.match.params.id } })
  const {
    loading: tireInfoLoading, data: tireInfoData, error: tireInfoError, refetch: tireInfoRefetch,
  } = useQuery(TIRE_SERIAL_NUMBER_INFO_FOR_TIRE_PATCH_LOG, { skip: _.isUndefined(tireInfoId), variables: { id: tireInfoId, patchDate } })

  const [mutationVariables, setMutationVariables] = useState(isAddMode
    ? { type: 'WORMPILL' }
    : {})

  const onChangeHandler = (id, value) => {
    if (id === 'price') {
      setMutationVariables({
        ...mutationVariables,
        [id]: parseFloat(value),
      })
    } else if (id === 'truckId') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value.truckId,
        plateNumber: value.plateNumber,
      })
    } else if (id === 'trailerId') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value.trailerId,
        trailerPlate: value.trailerPlate,
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }

  useEffect(() => {
    if (!isAddMode && !loading) {
      setMutationVariables({
        ...mutationVariables,
        ...data.TirePatchLogInfo,
        driverId: data.TirePatchLogInfo.Driver.id,
        serialId: data.TirePatchLogInfo.Serial.id,
        tirepatchstoreId: data.TirePatchLogInfo.TirePatchStore.id,
        truckId: data.TirePatchLogInfo.Truck?.id,
        trailerId: data.TirePatchLogInfo.Trailer?.id,
        plateNumber: data.TirePatchLogInfo.Truck?.plateNumber,
        trailerPlate: data.TirePatchLogInfo.Trailer?.trailerPlate,
      })
      setTireInfoId(`${data.TirePatchLogInfo.Serial.id}`)
      setPatchDate(data.TirePatchLogInfo.patchDate)
      setTirePatchStore(data.TirePatchLogInfo.TirePatchStore)
    }
  }, [loading])

  useEffect(() => {
    if (isAddMode) {
      setMutationVariables({
        ...mutationVariables,
        truckId: tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TruckTires?.Truck?.id || tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TrailerTires?.Trailer?.truck?.id || undefined,
        trailerId: tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TruckTires?.Truck?.trailer?.id || tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TrailerTires?.Trailer?.id || undefined,
        plateNumber: tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TruckTires?.Truck?.plateNumber || tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TrailerTires?.Trailer?.truck?.plateNumber || undefined,
        trailerPlate: tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TruckTires?.Truck?.trailer?.trailerPlate || tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TrailerTires?.Trailer?.trailerPlate || undefined,
      })
    }
  }, [tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TruckTire, tireInfoData?.TireSerialNumberInfoForTirePatchLog?.TrailerTires])

  // if (!isAddMode && loading && _.isEmpty(data)) return <Loading center='true' />
  if (!isAddMode && _.isEmpty(data)) return <Loading center='true' />
  if (!isAddMode && error) return <P>เกิดข้อผิดพลาด</P>
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? detailType(props.match.params, mutationVariables, onChangeHandler, setTireInfoId, setPatchDate, tireInfoData, tirePatchStore, setTirePatchStore)
          : <Div>
            {
              detailType(props.match.params, mutationVariables, onChangeHandler, setTireInfoId, setPatchDate, tireInfoData, tirePatchStore, setTirePatchStore, data.TirePatchLogInfo) // argument mode
            }
          </Div>
      }
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <ActionBar
            loading={mutationLoading}
            disabled={_.isUndefined(mutationVariables.patchDate) || _.isEmpty(mutationVariables.patchDate)
              || _.isUndefined(mutationVariables.serialId)
              || _.isUndefined(mutationVariables.driverId)
              || _.isUndefined(mutationVariables.price) || _.isNaN(mutationVariables.price)
              || _.isUndefined(mutationVariables.type) || _.isEmpty(mutationVariables.type)
              || _.isUndefined(mutationVariables.tirepatchstoreId)}
            isAddMode={isAddMode}
            isViewMode={isViewMode}
            doAction={doAction}
            mutationVariables={{ ...mutationVariables }}
            props={props}
            refetch={refetch}
            setMutationVariables={setMutationVariables}
          />
          : <ActionBar
            isAddMode={isAddMode}
            isViewMode={isViewMode}
            props={props}
            mutationVariables={{ ...mutationVariables }}
            refetch={refetch}
            setMutationVariables={setMutationVariables}
          />
      }
    </Div>
  )
}

export default Index
export { Index }
